export default __webpack_public_path__ + "static/media/831.5b828598.png";